import type { TNumberRange } from '@cascade/core/utils';
import type { TTranslate } from '@cascade/react/i18n';

export const describeNumberRange = (
  translate: TTranslate,
  { min, max }: TNumberRange,
  locale: string,
): string => {
  const minText = min?.toLocaleString(locale);
  const maxText = max?.toLocaleString(locale);

  if (minText && maxText) {
    return translate('experience.number.between', {
      min: minText,
      max: maxText,
    });
  }

  if (minText) {
    return translate('experience.number.atLeast', { min: minText });
  }

  if (maxText) {
    return translate('experience.number.atMost', { max: maxText });
  }

  return translate('experience.number.invalid');
};
